import { Button, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { ButtonVariant } from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

const SidebarRequestCard: FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <AppCard bgColor={Color.Primary500} p="15px">
      <Text mb="15px" color={Color.OnPrimary}>
        {t('peSidebarRequestCardText')}
      </Text>
      <Button
        w="full"
        onClick={() => navigate(AppRoute.createPeOrder)}
        variant={ButtonVariant.Light}
      >
        {t('leaveRequest')}
      </Button>
    </AppCard>
  );
};

export default SidebarRequestCard;
